import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
// import { useSearchParams } from "react-router-dom";
import styled from "styled-components/macro";

import { atomicConfig } from "../../../config";
import { trackEvent } from "../../../utils/analytics";
import { call_api_auth } from "../../../utils/services";
import { ReactComponent as Logo } from "../../../vendor/logo-dark.svg";

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

const Brand = styled(Logo)`
  width: 150px;
  height: 50px;
  margin-bottom: 20px;
`;

const LogoCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

function AmazonConnect() {
  const [loading, setLoading] = useState(false);

  // Check if this is a Marketplace-initiated flow
  const params = new URLSearchParams(window.location.search);
  const amazonCallbackUri = params.get("amazon_callback_uri");
  const amazonState = params.get("amazon_state");

  if (amazonCallbackUri && amazonState) {
    const redirectUri = encodeURIComponent(
      "https://dashboard.atomic-growth.com/auth/amazon/callback"
    );
    const separator = amazonCallbackUri.includes("?") ? "&" : "?";
    window.location.href = `${amazonCallbackUri}${separator}redirect_uri=${redirectUri}&amazon_state=${amazonState}`;
    return (
      <Wrapper>
        <CircularProgress />
        <Typography>Redirecting to Amazon...</Typography>
      </Wrapper>
    );
  }

  const handleConnect = async () => {
    trackEvent("amazon_connect_initiated");
    setLoading(true);
    try {
      const url = atomicConfig.userServiceUrl + "/amazon/connect";
      const res = await call_api_auth(url, "GET");

      if (res.error) throw new Error(res.error);

      trackEvent("amazon_connect_redirecting");
      window.location.href = res.data.redirect_url;
    } catch (err) {
      trackEvent("amazon_connect_error", { error: err.message });
      console.error("Amazon connect error:", err);
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Wrapper>
        <LogoCenter>
          <Brand />
        </LogoCenter>
        <Helmet title="Connect Amazon Seller Central" />

        <Typography component="h1" variant="h4" align="center" gutterBottom>
          Connect Amazon Seller Central
        </Typography>
        <Typography
          component="h2"
          variant="body1"
          align="center"
          sx={{ mb: 4, color: "text.secondary" }}
        >
          Link your Amazon Seller Central account to get started with analytics
          and insights.
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src="https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg"
            alt="Amazon"
            sx={{ width: 120, mb: 2 }}
          />

          <Typography
            variant="body2"
            align="center"
            sx={{ color: "text.secondary", mb: 2 }}
          >
            By connecting your account, you authorize us to access your seller
            data for reporting and analytics purposes.
          </Typography>

          <Button
            variant="contained"
            size="large"
            onClick={handleConnect}
            disabled={loading}
            sx={{
              backgroundColor: "#FF9900",
              color: "#111",
              fontWeight: 600,
              px: 5,
              py: 1.5,
              "&:hover": { backgroundColor: "#e88b00" },
            }}
          >
            {loading ? (
              <CircularProgress size={24} sx={{ color: "#111" }} />
            ) : (
              "Connect with Amazon"
            )}
          </Button>
        </Box>
      </Wrapper>
    </React.Fragment>
  );
}

export default AmazonConnect;
